import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import menuSlice from './slices/menuSlice';
import cartSlice from './slices/cartSlice';
import orderSlice from './slices/orderSlice';
import voiceSlice from './slices/voiceSlice';
import themeSlice from './slices/themeSlice';
import companySlice from './slices/companySlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    menu: menuSlice,
    cart: cartSlice,
    order: orderSlice,
    voice: voiceSlice,
    theme: themeSlice,
    company: companySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['voice/setAudioData'],
        ignoredPaths: ['voice.audioData'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;